import HttpClient from "@/services/HttpClient";
import StoreService from "@/store";
import { EServices } from "@/types";
import JsonResponse from "@/utils/http/JsonResponse";
import JsonResponseErrors from "@/utils/http/JsonResponseErrors";
import IJsonResponse from "@/utils/types/IJsonResponse";
import { inject, injectable } from "tsyringe";
import { IAccount } from "../types";
import { ICustomer } from "@/modules/banks/types";

@injectable()
export default class AuthClient {
  constructor(
    @inject(EServices.http) private http: HttpClient,
    @inject(EServices.store) private store: StoreService
  ) {}

  async register(
    firstName: string,
    lastName: string,
    username: string,
    email: string,
    password: string,
    captchaToken: string
  ): Promise<IJsonResponse> {
    console.log("Got to Client register");
    const response = await this.http.post("/v1/auth/create", {
      firstName,
      lastName,
      username,
      email,
      password,
      captchaToken,
    });
    console.log("Got to Client register response", response);
    this.store.commit(
      "AccountModule/setToken",
      (response.baseResponse &&
        response.baseResponse.headers.get("authorization")) ||
        undefined
    );

    // const customer = await this.http.get(
    //   `/v1/app/customers/${response.data.id}`
    // );

    this.store.commit("AccountModule/setAccount", response.data);
    // this.store.commit("AccountModule/setCustomer", customer.data);

    return response;
  }

  async linkReferralToReferrer(
    accountId: number,
    referredBy?: string
  ): Promise<IJsonResponse> {
    const response = await this.http.post("/v1/app/referrals", {
      accountId,
      referredBy,
    });

    return response;
  }

  async login(
    userId: string,
    password: string,
    captchaToken: string
  ): Promise<IJsonResponse> {
    const response = await this.http.post("/v1/auth/login", {
      userId,
      password,
      captchaToken,
    });
    const account: IAccount = response.data;
    if (account.role.name != "customer")
      throw await JsonResponse.createJsonResponse(
        undefined,
        new JsonResponseErrors(
          "you cannot access this service with this account"
        )
      );

    //Fetch the customer phone
    // const customer = await this.http.get(`/v1/app/customers/${account.id}`);

    this.store.commit(
      "AccountModule/setToken",
      (response.baseResponse &&
        response.baseResponse.headers.get("authorization")) ||
        undefined
    );
    this.store.commit("AccountModule/setAccount", response.data);
    // this.store.commit("AccountModule/setCustomer", customer.data);

    return response;
  }

  async oldLogin(userId: string, password: string): Promise<IJsonResponse> {
    const response = await this.http.post("/v1/auth/login/old", {
      userId,
      password,
    });
    const account: IAccount = response.data;
    if (account.role.name != "App.oldCustomer")
      throw await JsonResponse.createJsonResponse(
        undefined,
        new JsonResponseErrors(
          "you cannot access this service with this account"
        )
      );

    this.store.commit("AccountModule/setToken", "oldCustomer");
    this.store.commit("AccountModule/setAccount", {
      ...response.data,
      firstName: response.data.firstname,
      lastName: response.data.lastname,
    } as IAccount);

    return response;
  }

  async sendPasswordOtp(
    email: string,
    captchaToken: string
  ): Promise<IJsonResponse> {
    return await this.http.post("/v1/auth/recovery/send", {
      email,
      captchaToken,
    });
  }

  async verifyPasswordOtp(otp: string, email: string): Promise<IJsonResponse> {
    return await this.http.put("/v1/auth/recovery/verify", {
      email,
      otp,
    });
  }

  async resetPassword(email: string, newPassword: string, otp: string) {
    await this.http.post("/v1/auth/recovery/reset", {
      email,
      newPassword,
      otp,
    });
  }

  async savePassword(
    newPassword: string,
    confirmPassword: string,
    email: string
  ): Promise<IJsonResponse> {
    return await this.http.post("/v1/auth/password/save", {
      newPassword,
      confirmPassword,
      email,
    });
  }

  async getAccountDetailsByEmailOrUsername(
    role: string,
    emailOrUsername: string
  ): Promise<IAccount> {
    const response = await this.http.get(
      `/v1/auth/account/find/${role}/${emailOrUsername}`
    );
    return response.data;
  }

  async getCustomer(id: number): Promise<ICustomer> {
    const response = await this.http.get(`/v1/app/customers/${id}`);

    this.store.commit("AccountModule/setCustomer", response.data);
    return response.data;
  }
}
